import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CalculoBaseImponible } from '@shared/enums/CalculoBaseImponible';
import { Renglon } from '@shared/models/facturacion/Renglon';

@Component({
  selector: 'app-visor-impuesto',
  templateUrl: './visor-impuesto.component.html',
  styleUrls: ['./visor-impuesto.component.css']
})
export class VisorImpuestoComponent implements OnInit {
  @Input() renglones: Renglon[];
  contador = 0;
  constructor(public activeModal: NgbActiveModal ) { }

  ngOnInit() {
    console.log(this.renglones);
  }

  obtenerBaseCalculo(cal: number){
    return CalculoBaseImponible[cal];
  }

  incrementarContador(total: number){
      this.contador++;
      if (total < this.contador) {
        this.contador = 1;
      }
      return this.contador;
  }

}
